/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { DraftFilter } from '../../../../types/DraftFilter';
import { DraftSort } from '../../../../types/DraftSort';

export const DraftSearchRequest: core.serialization.Schema<
    serializers.DraftSearchRequest.Raw,
    Truvity.DraftSearchRequest
> = core.serialization.object({
    filter: core.serialization.list(DraftFilter).optional(),
    sort: core.serialization.list(DraftSort).optional(),
});

export declare namespace DraftSearchRequest {
    export interface Raw {
        filter?: DraftFilter.Raw[] | null;
        sort?: DraftSort.Raw[] | null;
    }
}
